import Icons from "icons/sidebar";
import { MenuItem } from "./topMenuList";

const index: MenuItem[] = [
  {
    title: "Agendamento",
    Icon: Icons.ScheduleIcon,
    path: "/customer-access/schedule",
  },
  {
    title: "Reservas",
    Icon: Icons.UserManagementIcon,
    path: "/customer-access/reservations",
  },
];

export default index;
